import { Injectable, ViewChild, TemplateRef } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse,
    HttpErrorResponse
} from '@angular/common/http';
import { map, catchError, tap } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
// import { ErrorDialogService } from './error-dialog.service';
import { LocalStorageService } from './local-storage.service';
import { GlobalService } from './global.service';
import { LoginService } from './login.service';
import * as moment from 'moment';

const devUrl = environment.backendurl

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    @ViewChild('error') error: TemplateRef<any>;

    tokenExpirationTime: number = 8;
    ontheflyUrls: Array<string> = [
        "/user/register",
        "/user/login",
        "/user/forgotpassword",
        "/user/changepassword",
        "/verifyemail",
        "/extension/feedback",
        "/searchtoolbox/iframerelated_data",
        "/searchtoolbox/iframeautocomplete_dropdown_data",
        "/searchtoolbox/iframelinkedinsearch",
        "/searchtoolbox/iframexingsearch",
        "/searchtoolbox/iframequorasearch",
        "/searchtoolbox/iframegithubsearch",
        "/searchtoolbox/iframestackoverflowsearch",
        "/searchtoolbox/iframebehancesearch",
        "/searchtoolbox/iframetwittersearch",
        "/user/resendverifyemail",
        "/federatedlinkedinlogin",
        "/user/isresetlinkvalid",
        "/candidate/unsubscribe"
    ];

    constructor(
        // private errorDialogService: ErrorDialogService,
        private loginService: LoginService,
        private _localStorageService: LocalStorageService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let token: string;
        let timeKey: string;

        if (this.ontheflyUrls.includes(request.url.replace(devUrl, ''))) { 
            token = sessionStorage.getItem('token');
            timeKey = sessionStorage.getItem('emit');
            if (!token || !timeKey ) {
                if (timeKey && moment().diff(parseInt(timeKey), 'hours') > this.tokenExpirationTime) {
                    return this.getOntheflyToken(request, next);
                } else {
                    return this.getOntheflyToken(request, next);
                }
            } else {
                return this.requestWithHeaders(token, request, next);
            }
        } else {
            token = this._localStorageService.getItem('token');
            return this.requestWithHeaders(token, request, next);
        }
    } 

    getOntheflyToken (request: HttpRequest<any>, next: HttpHandler): any {
        this.loginService.ontheflytoken({ agent: window.navigator.userAgent })
        .pipe(
            tap((res: any) => {
                if (res.message && res.message.token) {
                    // save token in local storage
                    sessionStorage.setItem('token', res.message.token);

                    // save current time in local storage
                    sessionStorage.setItem('emit', `${+new Date()}`);
                    return this.requestWithHeaders(res.message.token, request, next);
                } else {
                    catchError(GlobalService.handleError('onthefly api', ''));
                }
            })
        );
    }

    requestWithHeaders (token: string, request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (token) {
            request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token), withCredentials: true });
        } else {
            request = request.clone({ withCredentials: true });
        }

        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    // console.log('event--->>>', event);
                    // this.errorDialogService.openDialog(event);
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                let data: any = {};
                data = {
                    reason: error && error.error && error.error.reason ? error.error.reason : '',
                    status: error.status
                };
                let errMsg = `reason: ${data.reason} status: ${data.status}`;
              //  console.log(`${errMsg}:`, error)

                if (error.status === 0) {
                    data['errormessage'] = "Some error has occured. Please try again later."
                    console.log(data,"error")
                    // this.errorDialogService.openDialog(data);
                }
                else if (error.status === 401) {
                    localStorage.clear();
                    let visitedURL = window.location.href.replace(window.location.origin, "")
                    if (visitedURL && visitedURL != "null" && visitedURL != "undefined" && !visitedURL.includes('signup') && !visitedURL.includes('login')) {
                        window.location.href = `/login?redirect=${visitedURL}`
                    } else {
                        window.location.href = '/login'
                    }
                }
                else if (error.status === 440) {
                    data['errormessage'] = "Session Expired. Kindly login again."
                    console.log(data,"error")
                    // this.errorDialogService.openDialog(data);
                }
                else if (error.status === 502 || error.status === 504)
                    window.location.href = '/serverdown'
                // else if (error.status === 404)
                //     window.location.href = '/pagenotfound'

                return throwError(error);
            }));        
    }
}